import { AHThemeType, AHIconType } from "arkh";

type TaskSentiment = "POSITIVE" | "NEGATIVE" | "NEUTRAL";

export const getIconName = (sentiment: TaskSentiment): AHIconType => {
  switch (sentiment) {
    case "POSITIVE":
      return "check";
    case "NEGATIVE":
      return "clear";
    case "NEUTRAL":
    default:
      return "check";
  }
};
export const getColor = (sentiment: TaskSentiment, theme: AHThemeType) => {
  switch (sentiment) {
    case "POSITIVE":
      return theme.positive;
    case "NEGATIVE":
      return theme.negative;
    case "NEUTRAL":
    default:
      return "black";
  }
};
